export const palette = {
    burgundy: {
        100: '#E6DFE3',
        200: '#CEBFC8',
        300: '#B59FAC',
        400: '#9D7F91',
        500: '#855F76',
        600: '#6C3F5A',
        700: '#541F3F',
        800: '#3C0024',
    },
    sand: {
        100: '#FFFBF4',
        200: '#FFF8EB',
        300: '#FFF4DF',
        400: '#CCC3B2',
        500: '#999285',
        600: '#666159',
        700: '#32302C',
    },
    orange: {
        100: '#FFD1CD',
        200: '#FF998B',
        300: '#FF510D',
        400: '#C22700',
        500: '#872500',
        600: '#501300',
        700: '#270500',
    },
    blue: {
        100: '#D8EBF9',
        200: '#86C8EF',
        300: '#57A2C9',
        400: '#227BA9',
        500: '#2C576D',
        600: '#183544',
        700: '#07161E',
    },
    success: {
        100: '#E7F9EB',
        500: '#0D7300',
    },
    white: '#FFFFFF',
} as const;

export const colors = {
    brandPrimary: palette.burgundy[800],
    brandCta: palette.orange[300],
    brandCtaHover: palette.orange[400],
    bgPage: palette.sand[100],
    bgCard: palette.sand[300],
    textDefault: palette.sand[700],
    textMuted: palette.sand[600],
    border: palette.sand[400],
    link: palette.blue[400],
    white: palette.white,
} as const;
